module.exports = __webpack_public_path__ + "static/img/vip1.3aecee5a.png";